<script setup lang="ts">
interface Props {
	text: string;
	severity?: 'secondary'
}

defineProps<Props>()
</script>

<template>
	<div :class="['faq-button', {'faq-button--secondary': severity === 'secondary'}]">
		<div class="faq-button__question">
			<i class="icon i-filled-question"></i>
		</div>
		<div class="faq-button__text">{{ text }}</div>
		<div class="faq-button__icon">
			<i class="icon icon-next"></i>
		</div>
	</div>
</template>

<style scoped lang="scss">
.faq-button {
	display: flex;
	align-items: center;
	gap: 8px;
	cursor: pointer;
	padding: 12px 16px;
	border-radius: 8px;
	background-color: var(--white1);

	&__question {
		width: 24px;
		height: 24px;
	}

	&--secondary {
		background-color: #F7F7F8;
	}

	&__text {
		font-size: 14px;
		font-weight: 500;
		line-height: 120%;
	}

	&__icon {
		display: flex;
		align-items: center;
		justify-content: center;
		width: 16px;
		height: 16px;
		margin-left: auto;

		i {
			color: var(--grey8);
		}
	}
}
</style>
